import { render, staticRenderFns } from "./chihongleaveImportform.vue?vue&type=template&id=305a00c0&scoped=true&"
import script from "./chihongleaveImportform.vue?vue&type=script&lang=js&"
export * from "./chihongleaveImportform.vue?vue&type=script&lang=js&"
import style0 from "./chihongleaveImportform.vue?vue&type=style&index=0&id=305a00c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a00c0",
  null
  
)

export default component.exports